import styled from 'styled-components';

export const Container = styled.div`
    padding: 15px 16px 0 16px;
    height: 100%;

    .content-header-list{
        display: flex;
        margin-left: 20; 
        justify-content: space-between; 
        width: 100%;
        
        .btn-new-list{
            float: right; 
            margin-right: 20;
        }
    }

    @media only screen and (max-width: 480px) {

        .space-search{
            margin: 2px 0px;
            width: 100% !important;
        }
    }

    @media only screen and (min-width: 481px) and (max-width: 630px) {
        .space-search{
            margin: 2px 0px;
            width: 100% !important;
        }
    }

    @media only screen and (min-width: 630px) and (max-width: 768px) {
        .space-search{
            margin: 2px 2px;
            width: 220px !important;
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 992px) {

        .space-search{
            margin: 2px 2px;
        }
    }

    @media only screen and (min-width: 992px) and (max-width: 1200px) {

        .space-search{
            margin: 2px 2px;
            width: 190px !important;
        }
    }

    @media only screen and (min-width: 1200px) and (max-width: 1600px) {

        .space-search{
            margin: 2px 2px;
            width: 100% !important;
        }
    }

    @media only screen and (min-width: 1600px) and (max-width: 1900px) {

        .space-search{
            margin: 2px 2px;
            width: 230px !important;
        }
    }

    .space-search{
        margin: 2px 2px;
        width: 250px;
    }

    .pl-15{
        padding-left: 0px !important;
    }

    .ml-15{
        margin-left: 0px !important;
    }

    .report-style-class{
        height: calc(100vh - 190px);
        width: 100%;
        iframe{
            border: 0.5px solid #ffffff61 !important;
            background: #F8F8F8 0% 0% no-repeat padding-box;
            opacity: 1;
        }
    }

    .report-style-class-custom{
      height: 100%;
      width: 100%;
      iframe{
          border: 0.5px solid #ffffff61 !important;
          background: #F8F8F8 0% 0% no-repeat padding-box;
          opacity: 1;
      }
    }

    .report-style-class-landing-page{
      height: 100%;
      width: 100%;
      iframe{
          border: 0.5px solid #ffffff61 !important;
          background: #F8F8F8 0% 0% no-repeat padding-box;
          opacity: 1;
      }
  }
`;